import { render, staticRenderFns } from "./Investment.vue?vue&type=template&id=c7197d8e&scoped=true"
import script from "./Investment.vue?vue&type=script&setup=true&lang=ts"
export * from "./Investment.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Investment.vue?vue&type=style&index=0&id=c7197d8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7197d8e",
  null
  
)

export default component.exports